import {
	DeviceState,
	DeviceStatus,
} from "Infrastructure/Models/Messages/Dto/DeviceStatus";
import { FunctionComponent, useState } from "react";
import { CircularProgress, Stack } from "@mui/material";
import { HubConnection, HubConnectionState } from "@microsoft/signalr";
import { CloseDialogHandler } from "Infrastructure/Providers/DialogProvider/DialogProvider";
import { ProductEnableDisableMessage } from "Infrastructure/Models/Messages/Messages";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { logError } from "Infrastructure/Utils/LoggingUtils";
import InstanceResponseContent from "../InstanceResponseContent";
import ProductActions from "./ProductActions";
import useProductDeviceModel from "Infrastructure/Hooks/useProductDeviceModel";

interface Props {
	deviceStatuses: DeviceStatus[] | null;
	deviceStatus?: DeviceStatus | undefined;
	hubConnection: HubConnection | null;
	closeDialog: CloseDialogHandler;
}

const ProductsDialogContent: FunctionComponent<Props> = (props) => {
	const { deviceStatuses, deviceStatus, hubConnection, closeDialog } = props;
	const showSnackbar = useSnackbar();
	const { t } = useResource();

	const { productDeviceModel, isLoading } = useProductDeviceModel(
		hubConnection,
		deviceStatuses,
		deviceStatus
	);

	const [messageResponse, setMessageResponse] = useState<{
		actionName: string;
		requestId?: string | null;
		deviceNames: string[];
	} | null>(null);

	const handleProductEnableDisable = (
		productEnableDisableMessage: ProductEnableDisableMessage
	) => {
		if (
			!hubConnection ||
			hubConnection.state !== HubConnectionState.Connected
		) {
			showSnackbar(t(Resources.Errors.Hub.ConnectionError), "error");
			return;
		}
		setMessageResponse({
			actionName: "Zapnutí/vypnutí",
			requestId: productEnableDisableMessage.requestId,
			deviceNames: productEnableDisableMessage.filteredDeviceNames,
		});
		hubConnection
			.invoke("productEnableDisable", productEnableDisableMessage)
			.catch((error: Error) => {
				showSnackbar(t(Resources.Errors.Hub.RequestError), "error");
				logError(error);
			});
	};

	if (messageResponse) {
		return (
			<InstanceResponseContent
				actionName={messageResponse.actionName}
				requestId={messageResponse.requestId}
				deviceNames={messageResponse.deviceNames}
				hubConnection={hubConnection}
				closeDialog={closeDialog}
			/>
		);
	}

	return (
		<Stack direction="column">
			{isLoading ? (
				<>
					<CircularProgress />
				</>
			) : (
				<>
					{deviceStatuses && deviceStatuses?.length > 0 && (
						<ProductActions
							deviceStatuses={deviceStatuses}
							deviceStatus={deviceStatus}
							productDeviceModel={productDeviceModel}
							hubConnection={hubConnection}
							closeDialog={closeDialog}
							onEnableDisable={handleProductEnableDisable}
						/>
					)}
				</>
			)}
		</Stack>
	);
};

export default ProductsDialogContent;
